import {PhoneNumberFormat, PhoneNumberUtil} from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isValidTelephoneNumber = (input, countryCode = 'ZA') => {
    try {
        const number = phoneUtil.parseAndKeepRawInput(input, countryCode);
        return phoneUtil.isValidNumber(number);
    }
    catch(err) {

    }

    return false;
};

export const normalizeTelephoneNumber = (input, countryCode = 'ZA') => {
    if (!isValidTelephoneNumber(input,countryCode))
        return undefined;

    const number = phoneUtil.parseAndKeepRawInput(input, countryCode);
    return phoneUtil.format(number, PhoneNumberFormat.E164)
};

// Returns { ok, e164, reason } so callers can show a specific cause to the user
// (e.g. "Phone number too short", "Prefix not recognised").
export const validatePhoneNumber = (input, countryCode = 'ZA') => {
    if (input === undefined || input === null || String(input).trim() === '') {
        return { ok: false, e164: null, reason: 'Missing phone number' };
    }

    let number;
    try {
        number = phoneUtil.parseAndKeepRawInput(String(input), countryCode);
    } catch (err) {
        return { ok: false, e164: null, reason: `Not a valid phone number format: "${input}"` };
    }

    if (phoneUtil.isValidNumber(number)) {
        return { ok: true, e164: phoneUtil.format(number, PhoneNumberFormat.E164), reason: null };
    }

    // Number parsed but failed validation — let libphonenumber classify why
    // instead of re-deriving it from digit counts.
    const { ValidationResult } = PhoneNumberUtil;
    switch (phoneUtil.isPossibleNumberWithReason(number)) {
        case ValidationResult.TOO_SHORT:
            return { ok: false, e164: null, reason: 'Phone number too short' };
        case ValidationResult.TOO_LONG:
            return { ok: false, e164: null, reason: 'Phone number too long' };
        case ValidationResult.INVALID_LENGTH:
            return { ok: false, e164: null, reason: 'Phone number length not valid' };
        case ValidationResult.INVALID_COUNTRY_CODE:
            return { ok: false, e164: null, reason: 'Country code not recognised' };
        default: {
            // Length is plausible but the prefix is not recognised for this
            // country (e.g. ZA "075..." is not an allocated prefix). Surface it
            // so the user can see exactly which numbers were rejected.
            const national = String(number.getNationalNumber());
            return {
                ok: false,
                e164: null,
                reason: `Prefix "0${national.slice(0, 2)}" not recognised for ${countryCode}`,
            };
        }
    }
};